import React from 'react';
import DashboardLayout from '../../components/layout/DashboardLayout';
import { Gift, Tag, Sparkles } from 'lucide-react';

const PLACEHOLDER_OFFERS = [
  {
    id: 1,
    title: 'Early Bird Discount',
    description: 'Apply for any service before the end of the month and get 10% off.',
    badge: 'Limited Time',
    badgeColor: 'bg-amber-100 text-amber-700',
    icon: Tag,
    iconBg: 'bg-amber-50',
    iconColor: 'text-amber-500',
  },
  {
    id: 2,
    title: 'Bundle & Save',
    description: 'Apply for 3 or more services together and receive a special bundled rate.',
    badge: 'Popular',
    badgeColor: 'bg-blue-100 text-blue-700',
    icon: Sparkles,
    iconBg: 'bg-blue-50',
    iconColor: 'text-[#1C8DEE]',
  },
  {
    id: 3,
    title: 'Referral Reward',
    description: 'Refer a friend to Fly8 and earn credit towards your next service.',
    badge: 'Coming Soon',
    badgeColor: 'bg-gray-100 text-gray-500',
    icon: Gift,
    iconBg: 'bg-gray-50',
    iconColor: 'text-gray-400',
  },
];

export default function OffersPage() {
  return (
    <DashboardLayout>
      <div className="space-y-6">

        {/* Header */}
        <div>
          <h1 className="text-xl font-bold text-gray-900">Offers & Promotions</h1>
          <p className="text-sm text-gray-500 mt-1">
            Special deals and promotions available for your study abroad journey
          </p>
        </div>

        {/* Hero banner */}
        <div className="bg-gradient-to-r from-[#E8F4FD] to-blue-50 border border-[#1C8DEE]/20 rounded-xl p-6 flex items-center gap-5">
          <div className="w-14 h-14 rounded-2xl bg-[#1C8DEE] flex items-center justify-center flex-shrink-0 shadow-md shadow-[#1C8DEE]/20">
            <Gift className="w-7 h-7 text-white" />
          </div>
          <div>
            <h2 className="font-semibold text-gray-900 text-base">Exclusive student offers</h2>
            <p className="text-sm text-gray-500 mt-0.5">
              Personalised promotions and discounts will appear here as they become available.
            </p>
          </div>
        </div>

        {/* Placeholder offer cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {PLACEHOLDER_OFFERS.map(offer => {
            const Icon = offer.icon;
            return (
              <div
                key={offer.id}
                className="bg-white rounded-xl border border-gray-100 p-5 shadow-sm hover:shadow-md transition-shadow duration-200"
              >
                <div className="flex items-center justify-between mb-4">
                  <div className={`w-10 h-10 rounded-lg ${offer.iconBg} flex items-center justify-center`}>
                    <Icon className={`w-5 h-5 ${offer.iconColor}`} />
                  </div>
                  <span className={`text-xs font-medium px-2.5 py-1 rounded-full ${offer.badgeColor}`}>
                    {offer.badge}
                  </span>
                </div>
                <h3 className="text-sm font-semibold text-gray-900 mb-1.5">{offer.title}</h3>
                <p className="text-sm text-gray-500 leading-relaxed">{offer.description}</p>
              </div>
            );
          })}
        </div>

        {/* Coming soon footer */}
        <p className="text-center text-xs text-gray-400 py-2">
          More offers coming soon — check back regularly for the latest promotions.
        </p>
      </div>
    </DashboardLayout>
  );
}
